<template>
  <div>
    <Header/>
    <Navigationzj :toptNavi="4"/>
    <div class="xinwentou w1200">
      <em>新闻资讯</em>
    </div>
    <div class="news_list w1200" v-loading="qyloading">
      <ul>
        <li v-for="(item, index) in list" :key="index">
          <router-link :to="{path: '/NewsDetail', query:{id:item.id}}" target="_blank" :title="item.title">
            <div class="padd clearfix">
              <div class="news_list_l">
                <img v-real-img="item.filename" src="../../assets/images/zwtp.jpg" width="130" height="130">
              </div>
              <div class="news_list_r">
                <h3 class="atpresent_title">{{item.title}}</h3>
                <div class="news_list_c clearfix">
                  <em><img src="">{{item.addtime}}</em>
                  <em><img src=""> {{item.hit}}次</em>
                </div>
                <div class="news_list_b" v-html="escapeHTML(item.content)"></div>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="hxq_subpage">
      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="LoadData" />
    </div>
    <Footer/>
  </div>
</template>
<script>
import api from '@/api/news'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import vuelist from '@/utils/vue_list'
import Navigationzj from '@/components/Navigationzj'
import Pagination from '@/components/Pagination'

export default {
  name: 'News',
  mixins: [vuelist],
  components: {
    Header,
    Navigationzj,
    Footer,
    Pagination
  },
  data () {
    return {
      api,
      listQuery: {
        limit: 10,
        order: 'order_num',
        sort: 'asc'
      },
      qyloading: false
    }
  },
  mounted () {
    this.LoadData()
  },
  methods: {
    escapeHTML (untrusted) {
      return untrusted.replace(/<(?:.|\n)*?>/gm, '')
        .replace(/(&rdquo;)/g, '/"')
        .replace(/&ldquo;/g, '/"')
        .replace(/&mdash;/g, '-')
        .replace(/&nbsp;/g, '')
        .replace(/&gt;/g, '>')
        .replace(/&lt;/g, '<')
        .replace(/<[\w\s"':=/]*/, '')
    }
  }
}
</script>
<style scoped>
  .atpresent_title{
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/view/news/index.vue